// removed by extract-text-webpack-plugin
module.exports = {"container":"SFTab__container___3OodQ"};